import { render, staticRenderFns } from "./ReportShareV2.vue?vue&type=template&id=be1d2508&scoped=true"
import script from "./ReportShareV2.vue?vue&type=script&lang=js"
export * from "./ReportShareV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1d2508",
  null
  
)

export default component.exports